// extracted by mini-css-extract-plugin
module.exports = {"blade":"Blade_blade__-yI2H"};